/* eslint-disable import/no-cycle */
import { Stack, HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import FormOptions from '../formInputs/FormOptions';
import { FormBuilderComponentProps } from '../types';

function RadioFieldComponent({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.radio')} isAdvanced={isAdvanced || false} />
      <FormOptions type="radio" fieldId={fieldId} />
    </Stack>
  );
}

export const RadioField = React.memo(
  RadioFieldComponent,
  (prev, next) =>
    // eslint-disable-next-line
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
